<ion-col size="12" *ngIf="valgtAnleggAar && !isBrowser">
  <ion-row class="cost-info-row row-m">
    <ion-col>
      <h2 class="yearTitleText">Estimert kostnad per år</h2>
      <p class="text12" *ngIf="isPlusskunde">netto etter inntekt</p>
    </ion-col>
  </ion-row>
  <ion-row class="cost-info-row row-m">
    <ion-col *ngFor="let data of yearsForbruk" class="box-col-nokkeltall">
      <p>
        {{ data.year }}
        <span *ngIf="data.year === thisYear.toString()">(hittil)</span>
      </p>
      <p class="large-number-total">
        {{ toRoundNumber(data.sumKostnad) }}
        <span class="ion-hide-sm-down">kr</span>
      </p>
      <p class="ion-hide-sm-up">kr</p>
    </ion-col>
  </ion-row>
</ion-col>
